<template>
  <div>
    <el-tooltip content="Model info" popper-class="is-green">
      <el-button class="info-btn" type="primary" @click="openModal = true">
        <svgicon name="Info" />
      </el-button>
    </el-tooltip>
    <el-dialog
      :visible.sync="openModal"
      title="Model info"
      width="500px"
    >
      <div class="modal-field__label acr-bold-18">{{ modelName }}</div>
      <brand-list :list="brands" />
      <template slot="footer">
        <el-button @click="openModal = false">Cancel</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getModelInfo } from "@/api/projects";
import BrandList from '@/components/BrandList';

export default {
  components: { BrandList },
  name: "ModelInfo",
  data() {
    return {
      brands: [],
      modelName: '',
      openModal: false,
    }
  },
  watch: {
    openModal(value) {
      if (value) {
        this.getInfo();
      }
    },
  },
  methods: {
    async getInfo() {
      const { data = {} } = await getModelInfo(this.$route.params.projectId);
      this.brands = data.brands;
      this.modelName = data.model_name;
    },
  },
}
</script>

<style scoped lang="scss">
.info-btn {
  padding: 10px;

  svg {
    width: 16px;
    height: 16px;
    color: white;
  }
}
</style>
